import {
  fetchWithTokenAndRegion,
  getOxygenId,
  getCurrentToken,
  getBim360AdminUrl,
  getCurrentTokenWithoutRedirect,
} from '@adsk/acs-sc-web-platform-api';
import { CONTEXT_NAMES } from '@adsk/alloy-helpers';

import {
  createDataStore,
  DataStore,
} from '../helpers/createDataModificationStore';
import { parseUser } from '../helpers/parseUser';
import { User, UserDTO } from '../types';

export type UserStore = DataStore<User>;

const fetchUser = () =>
  getCurrentToken().then(({ accessToken }) => {
    const oxygenId = getOxygenId(accessToken);
    return fetchWithTokenAndRegion<UserDTO>(
      `${getBim360AdminUrl()}/v1/users/${oxygenId}`,
    ).then(parseUser);
  });

// Custom fetch function that handles the UserContext-specific auth logic
const createUserFetchFunction =
  (redirectLoggedOutUsers: boolean = true) =>
  async (): Promise<User> => {
    const fetchUserFn = redirectLoggedOutUsers
      ? fetchUser
      : () => getCurrentTokenWithoutRedirect().then(() => fetchUser());

    try {
      const result = await fetchUserFn();
      return result as unknown as User;
    } catch (error) {
      if (redirectLoggedOutUsers) {
        console.error(
          'AlloyProvider - UserContext: Error fetching current user',
          error,
        );
      }
      throw error;
    }
  };

export const useUserStore = (redirectLoggedOutUsers: boolean = true) =>
  createDataStore<User>({
    contextName: CONTEXT_NAMES.UserContext,
    fetchFunction: createUserFetchFunction(redirectLoggedOutUsers),
  })();
